exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider-wrapper {\n  width: 100%;\n}\n.status {\n  top: 43px;\n  font-size: 12px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/app/shared/slider/slider.component.less
// module id = ../../../../../src/app/shared/slider/slider.component.less
// module chunks = main